module.exports = {"450321100":"阳朔镇","450321101":"白沙镇","450321102":"福利镇","450321103":"兴坪镇","450321104":"葡萄镇","450321105":"高田镇","450321200":"金宝乡","450321201":"普益乡","450321202":"杨堤乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450321.json
// module id = 2098
// module chunks = 0